export default __webpack_public_path__ + "static/media/example-monzo-IMG.33a32673.jpg";